/**
 * Created by vladislav on 19/12/2022
 */

cc.MoveInArc = function (duration, center, angle) {
    cc.ActionInterval.call(this, duration);

    this._center = center;
    this._toAngle = angle;
};

cc.MoveInArc.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.MoveInArc,

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        this._startPosition = target.getPosition();
        this._startAngle = Math.atan2(this._startPosition.y - this._center.y, this._startPosition.x - this._center.x);
        this._radius = cc.pDistance(this._startPosition, this._center);
    },

    update: function (time) {
        time = this._computeEaseTime(time);
        const angle = this._startAngle + (this._toAngle - this._startAngle) * time;

        this.target.x = Math.cos(angle) * this._radius + this._center.x;
        this.target.y = Math.sin(angle) * this._radius + this._center.y;
    }
});